// extracted by mini-css-extract-plugin
export default {"createComments":"CreateComment_createComments__NlWB1","inputForm":"CreateComment_inputForm__YAFb7","addComment":"CreateComment_addComment__Kn4f9"};